import React from 'react';
import { ApplicationPage } from '../../components/applications/ApplicationPage';
import { educationPage } from '../../data/applicationPages';
export function EducationPage() {
  return <ApplicationPage content={educationPage} demoDomainId="education" data-id="element-1794" data-mp="6qq2hz0g4b9t" />;
}